import * as z from "zod";

export const TokenDataSchema = z.object({
  impersonatorId: z.string().optional(),
  userId: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  companyId: z.string(),
  hasAdminAccess: z.boolean(),
  hasSuperViewerAccess: z.boolean(),
  hasDepartmentAccess: z.boolean(),
  hasDepartmentPayrollAccess: z.boolean(),
  hasBusinessUnitAccess: z.boolean(),
  hasBusinessUnitPayrollAccess: z.boolean(),
  hasPaymentsAccess: z.boolean(),
  hasVendorAdminAccess: z.boolean(),
  hasUserAdminAccess: z.boolean().optional().default(false),
  hasFinancialAnalysisAccess: z.boolean(),
  departmentIds: z.array(z.string()),
  departmentNames: z.array(z.string()),
  businessUnitIds: z.array(z.string()),
  businessUnitNames: z.array(z.string()),
  groupIds: z.array(z.string()),
});

export type TokenData = z.infer<typeof TokenDataSchema>;

export const VendorTokenDataSchema = z.object({
  userId: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  vendorCompanyId: z.string(),
  companyId: z.string().optional(),
});

export const VendorCompanyWithCompanyTokenDataSchema =
  VendorTokenDataSchema.extend({
    companyId: z.string(),
  });

export type VendorTokenData = z.infer<typeof VendorTokenDataSchema>;
export type VendorWithCompanyTokenData = z.infer<
  typeof VendorCompanyWithCompanyTokenDataSchema
>;

export const CompanyTokenSchema = z.object({
  data: TokenDataSchema,
});

export const VendorCompanyTokenSchema = z.object({
  data: VendorTokenDataSchema,
});

export const VendorCompanyWithCompanyTokenSchema = z.object({
  data: VendorCompanyWithCompanyTokenDataSchema,
});

export function createBaseTokenData(): TokenData {
  return {
    impersonatorId: undefined,
    userId: "",
    email: "",
    firstName: "",
    lastName: "",
    companyId: "",
    hasAdminAccess: false,
    hasSuperViewerAccess: false,
    hasDepartmentAccess: false,
    hasDepartmentPayrollAccess: false,
    hasBusinessUnitAccess: false,
    hasBusinessUnitPayrollAccess: false,
    hasPaymentsAccess: false,
    hasVendorAdminAccess: false,
    hasUserAdminAccess: false,
    hasFinancialAnalysisAccess: false,
    departmentIds: [],
    departmentNames: [],
    businessUnitIds: [],
    businessUnitNames: [],
    groupIds: [],
  };
}
